import React from 'react';
import { Button, FormControl, InputLabel, Select, MenuItem, Switch, FormControlLabel } from '@mui/material';

export interface RapportSettingsProps {
  onClose: () => void;
}

const RapportSettings: React.FC<RapportSettingsProps> = ({ onClose }) => {
  const [exportFormat, setExportFormat] = React.useState('csv');
  const [includeHistory, setIncludeHistory] = React.useState(true);
  const [includeAlerts, setIncludeAlerts] = React.useState(true);
  const [dateRange, setDateRange] = React.useState('7');

  return (
    <div style={{ minWidth: 300, padding: 16, borderLeft: '1px solid #eee', background: '#fafafa' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h3>Paramètres du rapport</h3>
        <Button variant="outlined" size="small" onClick={onClose}>
          Fermer
        </Button>
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {/* Format d'export */}
        <FormControl fullWidth>
          <InputLabel>Format d'export</InputLabel>
          <Select
            value={exportFormat}
            label="Format d'export"
            onChange={(e) => setExportFormat(e.target.value)}
          >
            <MenuItem value="csv">CSV</MenuItem>
            <MenuItem value="xlsx">Excel</MenuItem>
            <MenuItem value="pdf">PDF</MenuItem>
          </Select>
        </FormControl>

        {/* Période d'analyse */}
        <FormControl fullWidth>
          <InputLabel>Période d'analyse</InputLabel>
          <Select
            value={dateRange}
            label="Période d'analyse"
            onChange={(e) => setDateRange(e.target.value)}
          >
            <MenuItem value="1">1 jour</MenuItem>
            <MenuItem value="7">7 jours</MenuItem>
            <MenuItem value="30">30 jours</MenuItem>
            <MenuItem value="90">90 jours</MenuItem>
          </Select>
        </FormControl>

        {/* Options d'inclusion */}
        <div style={{ marginTop: 16 }}>
          <h4 style={{ marginBottom: 12, fontSize: '1rem' }}>Inclure dans le rapport</h4>
          
          <FormControlLabel
            control={
              <Switch
                checked={includeHistory}
                onChange={(e) => setIncludeHistory(e.target.checked)}
              />
            }
            label="Données historiques"
          />
          
          <FormControlLabel
            control={
              <Switch
                checked={includeAlerts}
                onChange={(e) => setIncludeAlerts(e.target.checked)}
              />
            }
            label="Alertes récentes"
          />
        </div>

        {/* Actions */}
        <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 8 }}>
          <Button variant="contained" color="primary" fullWidth>
            Appliquer les paramètres
          </Button>
          <Button variant="outlined" fullWidth>
            Réinitialiser
          </Button>
        </div>

        {/* Informations */}
        <div style={{ marginTop: 24, padding: 12, background: '#e3f2fd', borderRadius: 4, fontSize: '0.85em' }}>
          <b>Aide :</b>
          <ul style={{ margin: '8px 0', paddingLeft: 16 }}>
            <li>CSV : Format compatible Excel</li>
            <li>Excel : Fichier .xlsx natif</li>
            <li>PDF : Document imprimable</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RapportSettings;
